/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceGroupMapUserAccountsRequest
 */
export interface DeviceGroupMapUserAccountsRequest {
    /**
     * List of UserAccountIds to be added to the group
     * @type {Array<number>}
     * @memberof DeviceGroupMapUserAccountsRequest
     */
    userAccountsToAdd?: Array<number>;
    /**
     * List of UserAccountIds to be removed from the group
     * @type {Array<number>}
     * @memberof DeviceGroupMapUserAccountsRequest
     */
    userAccountsToRemove?: Array<number>;
}

/**
 * Check if a given object implements the DeviceGroupMapUserAccountsRequest interface.
 */
export function instanceOfDeviceGroupMapUserAccountsRequest(
    value: object,
): value is DeviceGroupMapUserAccountsRequest {
    return true;
}

export function DeviceGroupMapUserAccountsRequestFromJSON(
    json: any,
): DeviceGroupMapUserAccountsRequest {
    return DeviceGroupMapUserAccountsRequestFromJSONTyped(json, false);
}

export function DeviceGroupMapUserAccountsRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceGroupMapUserAccountsRequest {
    if (json == null) {
        return json;
    }
    return {
        userAccountsToAdd:
            json["userAccountsToAdd"] == null
                ? undefined
                : json["userAccountsToAdd"],
        userAccountsToRemove:
            json["userAccountsToRemove"] == null
                ? undefined
                : json["userAccountsToRemove"],
    };
}

export function DeviceGroupMapUserAccountsRequestToJSON(
    value?: DeviceGroupMapUserAccountsRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        userAccountsToAdd: value["userAccountsToAdd"],
        userAccountsToRemove: value["userAccountsToRemove"],
    };
}
